jQuery(document).ready(function($){
    if ( $('.insights__featured__slider') ) {
        $('.insights__featured__slider').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: '<button class="nextbtn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M14.8365 18.6636L13.7673 17.6194L18.6462 12.7404H2.5V11.2406H18.6558L13.7923 6.36163L14.8365 5.31738L21.5095 11.9906L14.8365 18.6636Z" fill="white"/></svg></button>',
            appendArrows: $('.insights__featured__slider__nav'),
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 993,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        variableHeight: false,
                        fade: true,
                        dots: true,
                    }
                }
            ]
        });
    }
});